export const NAV_STATES = {
    meetings: 'Dashboard',
    search: 'Unified Search',
    calendar: 'My Calendar',
    // nested states
    'tasks.wizard': 'Schedule',
    'tasks.active': 'Tasks',
    'settings.billing': 'Billing',
    'settings.docgen.list': 'Documents',
    'settings.docgen.edit': 'Edit Document Template',
    'settings.meeting': 'Settings',
    'settings.platforms.list': 'Messengers & Plugins',
    'settings.accounts.list': 'Installed Integrations',
    'skills.list': 'CalendarHero Applications',
    'settings.crm': 'CRM Application Settings',
    'settings.integrations.list': 'Custom Applications',
    'settings.integrations.edit': 'Edit Custom Application',
    'settings.faq.list': 'Knowledge Base',
    'settings.faq.edit': 'Edit Knowledge Base',
    // user settings
    user: 'User Settings',
    'user.profile': 'User Profile',
    'user.assistant': 'My Assistant',
    'user.branding': 'Branding & Display',
    'user.email': 'Emails & Notifications',
    'user.collaborators': 'My Collaborators',
    'settings.user.weather': 'Weather',
    'settings.user.email': 'Emails',
    'settings.user.api': 'API',
    // meeting settings
    'settings.meeting.types': 'Meeting Types',
    'settings.meeting.directories': 'Meeting Directories',
    'settings.meeting.general': 'General Meeting Settings',
    'settings.meeting.rooms': 'Meeting Rooms',
    'settings.meeting.teams': 'Teams',
    'settings.accounts.add': 'Integrations',
    'org.apps.docgen.list': 'Corporate-Wide Document Generation Settings',
    'org.apps.faq.list': 'Corporate-Wide Knowledge Base Settings',
    'org.apps.integrations.list': 'Corporate-Wide CalendarHero Applications',
    'org.apps.meeting': 'Corporate-Wide Meeting Settings',
    'org.apps.whois': 'Corporate-Wide People Insight Settings',
    'org.accounts.list': 'Corporate-Wide Integrations',
    'org.apps.list': 'CalendarHero Applications',
    'org.accounts.add': 'Integrations Directory',
    'contacts.edit': 'Edit Contact',
    'contacts.list': 'Contacts'
};
